export const templatePoses = {
  standing: {
    name: "Standing",
    description: "Basic standing pose",
    data: {
      Spine: { x: 0, y: 0, z: 0 },
      Spine1: { x: 0, y: 0, z: 0 },
      Spine2: { x: 0, y: 0, z: 0 },
      Head: { x: 0, y: 0, z: 0 },
      LeftArm: { x: 0, y: 0, z: 0 },
      RightArm: { x: 0, y: 0, z: 0 },
      LeftLeg: { x: 0, y: 0, z: 0 },
      RightLeg: { x: 0, y: 0, z: 0 }
    }
  },
  sitting: {
    name: "Sitting",
    description: "Casual sitting pose",
    data: {
      Spine: { x: 5, y: 0, z: 0 },
      Spine1: { x: 5, y: 0, z: 0 },
      LeftUpLeg: { x: 85, y: 0, z: 0 },
      RightUpLeg: { x: 85, y: 0, z: 0 },
      LeftLeg: { x: -90, y: 0, z: 0 },
      RightLeg: { x: -90, y: 0, z: 0 }
    }
  },
  walking: {
    name: "Walking",
    description: "Mid-walk pose",
    data: {
      LeftUpLeg: { x: 45, y: 0, z: 0 },
      RightUpLeg: { x: -30, y: 0, z: 0 },
      LeftLeg: { x: -10, y: 0, z: 0 },
      RightLeg: { x: 30, y: 0, z: 0 },
      LeftArm: { x: -30, y: 0, z: 0 },
      RightArm: { x: 30, y: 0, z: 0 },
      LeftForeArm: { x: -15, y: 0, z: 0 },
      RightForeArm: { x: 15, y: 0, z: 0 }
    }
  },
  running: {
    name: "Running",
    description: "Dynamic running pose",
    data: {
      Spine: { x: 15, y: 0, z: 0 },
      LeftUpLeg: { x: 60, y: 0, z: 0 },
      RightUpLeg: { x: -45, y: 0, z: 0 },
      LeftLeg: { x: -15, y: 0, z: 0 },
      RightLeg: { x: 45, y: 0, z: 0 },
      LeftArm: { x: -60, y: 0, z: 0 },
      RightArm: { x: 45, y: 0, z: 0 },
      LeftForeArm: { x: -30, y: 0, z: 0 },
      RightForeArm: { x: 30, y: 0, z: 0 }
    }
  },
  waving: {
    name: "Waving",
    description: "Friendly waving pose",
    data: {
      RightArm: { x: -45, y: 0, z: 45 },
      RightForeArm: { x: -45, y: 0, z: 0 },
      RightHand: { x: 0, y: 0, z: 0 }
    }
  },
  thinking: {
    name: "Thinking",
    description: "Contemplative pose",
    data: {
      RightArm: { x: -90, y: 30, z: 0 },
      RightForeArm: { x: -60, y: 0, z: 0 },
      RightHand: { x: -30, y: 0, z: 0 },
      Head: { x: 5, y: -15, z: 0 }
    }
  }
};
